<script context="module">
  import { store } from './stores.js';
  import { isNullOrUndefined } from './Utils.svelte';
  import { fixed_product, fixed_machinable_state } from './ConfigUtils.svelte';

  const defaultProduct = "all";
  const defaultCategory = "all";
  const defaultPlaylist = "all";
  const defaultProject = "all";
  const defaultSearch = "all";

  export function is_default_product(product_name) {
    return isNullOrUndefined(product_name) || product_name == defaultProduct;
  }

  export function is_default_category(category_name) {
    return isNullOrUndefined(category_name) || category_name == defaultCategory;
  }

  export function is_default_playlist(playlist_name) {
    return isNullOrUndefined(playlist_name) || playlist_name == defaultPlaylist;
  }

  export function is_default_search(search) {
      return isNullOrUndefined(search) || search == defaultSearch;
  }

  export function is_default_project(project_name) {
      return isNullOrUndefined(project_name) || project_name == defaultProject;
  }

  export function is_machinable_only(machinable_only) {
    return !isNullOrUndefined(machinable_only) && machinable_only === "true";
  }

  export function handle_filters(product, category, playlist, project, video, search, machinable_only) {
    store.set_all(product, category, playlist, project, video, search, machinable_only);
  }


  export function category_filter(params) {
    return (category) => {
      if (is_default_category(params.category) || params.category == category.get_instance_name()) {
        return category.get_playlists(playlist_filter(params)).length > 0;
      } else {
        return false;
      }
    };
  }

  export function search_filter(params) {
      return (search) => {
          if (is_default_search(params.search) || params.search == search.get_instance_name()) {
              return search.get_search(search_filter(params)).length > 0;
          } else {
              return false;
          }
      };
  }

  export function playlist_filter(params) {
    return (playlist) => {
      if (is_default_playlist(params.playlist) || params.playlist == playlist.get_instance_name()) {
        return playlist.get_videos(video_filter(params)).length > 0;
      } else {
        return false;
      }
    };
  }

  export function project_filter(params) {
      return (project) => {
          if (is_default_project(params.project) || params.project == project.get_instance_name()) {
              return project.get_videos(video_filter(params)).length > 0;
          } else {
              return false;
          }
      };
  }

  export function video_related_filter(params) {
    return (video) => {
      if (!is_default_product(params.product)) {
        if (!video.is_product_supported(params.product)) {
          return false;
        }
      }

      return true;
    };
  }

  export function video_filter(params) {
    return function(video){
      if (!is_default_product(params.product)) {
        if (!video.is_product_supported(params.product)) {
          // console.warn(`Incompatible: ${video.get_instance_name()}`);
          return false;
        }
      }

      if (!video.is_trial_machinable() && is_machinable_only(params.machinable_only)) {
        return false;
      }

      if (!isNullOrUndefined(params.search)) {
        const term = params.search.trim();
        if (term.length == 0) {
          return true;
        }
        const tags = video.get_tags();
        if (tags.length == 0) {
          // console.error(`No tags for video ${video.get_instance_name()}`);
          return false;
        }
        //TODO Improve or use current from old browser which also needs improvement
        const terms = term.split(' ');
        for (let term of terms) {
          for (let tag of tags) {
            const lterm = term.toLowerCase();
            const ltag = tag.toLowerCase();
            if (lterm.includes(ltag) || ltag.includes(lterm)) {
              return true;
            }
          }
        }
        return false;
      }

      return true;
    };
  }

</script>
